import { Injectable } from '@angular/core';
import { LoggerService } from '../../core/services/logger.service';
import { UtilService } from '../../core/services/util.service';
import { environment } from 'src/environments/environment';

interface ChanelProviderVariables {
  userId: string;
}

@Injectable({
  providedIn: 'root',
})
export class DynamicsService {
  get nativeWindow(): Window {
    return window;
  }

  constructor(
    private logger: LoggerService,
    private utilService: UtilService,
  ) {}

  async loadDynamicsEnviromentVariables(): Promise<ChanelProviderVariables | null> {
    try {
      const enviromentString: string = await (
        window as any
      ).Microsoft.CIFramework.getEnvironment();
      const enviromentVairablesInJson = JSON.parse(enviromentString);
      this.logger.info('channel provider variables', enviromentString);
      const channelProviderVariables: ChanelProviderVariables =
        enviromentVairablesInJson;

      return channelProviderVariables;
    } catch (error) {
      this.logger.error(
        'não consegui carregar as variáveis do chanell provider',
        error,
      );
      return null;
    }
  }

  async initialize() {
    this.logger.info('DYNAMICS - Initializing DynamicsService.');
    this.loadCIFLib();
    this.logger.info('DYNAMICS - initialized successfully.');
  }
  // Adicione métodos para manipular o objeto window, se necessário
  private loadCIFLib(): void {
    this.utilService.getIframeEnvironment();

    let url = environment.cif_versao1_seguros_pf;
    this.logger.info('DYNAMICS - Loading Dynamics CIF Library from: ' + url);

    const script = document.createElement('script');
    script.src = url;
    script.type = 'text/javascript';
    script.async = true;
    script.setAttribute('data-crmurl', url);
    script.setAttribute('data-cifid', 'CIFMainLibrary');
    document.body.appendChild(script);
  }
}
